import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  Notif: {},
};

export const NotifSlice = createSlice({
  name: "Notif",
  initialState,
  reducers: {
    viewtNotif: (state, action) => {
      state.Notif = action.payload;
    },
  },
});

export const { viewtNotif } = NotifSlice.actions;

export default NotifSlice.reducer;
